import {MarkdownViewer} from '@github-ui/markdown-viewer'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {Suspense} from 'react'
import {graphql, useFragment} from 'react-relay'

import {FormElementLoading} from '../FormElementLoading'
import type {MarkdownElement_input$key} from './__generated__/MarkdownElement_input.graphql'

export type MarkdownElementInternalProps = {
  verifiedHTML: SafeHTMLString
  type: 'markdown'
}

export const MarkdownElement = ({elementRef}: {elementRef: MarkdownElement_input$key}) => {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment MarkdownElement_input on IssueFormElementMarkdown {
        contentHTML
      }
    `,
    elementRef,
  )

  /* eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string */
  return <MarkdownElementInternal verifiedHTML={data.contentHTML as SafeHTMLString} type={'markdown'} />
}

export const MarkdownElementInternal = ({verifiedHTML}: MarkdownElementInternalProps) => {
  return (
    // The Suspense boundary is required since MarkdownViewer doesn't seem to be SSR-compatible
    <Suspense fallback={<FormElementLoading />}>
      <MarkdownViewer verifiedHTML={verifiedHTML} />
    </Suspense>
  )
}

try{ MarkdownElement.displayName ||= 'MarkdownElement' } catch {}
try{ MarkdownElementInternal.displayName ||= 'MarkdownElementInternal' } catch {}